// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Styles from "../../Styles.bs.js";
import * as RimbleUi from "rimble-ui";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";

var faqExplainerText = Curry._1(Css.style, {
      hd: Css.paddingTop({
            NAME: "px",
            VAL: 10
          }),
      tl: {
        hd: Css.paddingBottom({
              NAME: "px",
              VAL: 10
            }),
        tl: {
          hd: Css.lineHeight({
                NAME: "rem",
                VAL: 1.6
              }),
          tl: /* [] */0
        }
      }
    });

var accordionContent = Curry._1(Css.style, {
      hd: Css.overflow(Css.hidden),
      tl: {
        hd: Css.transition(800, 0, Css.ease, "all"),
        tl: /* [] */0
      }
    });

function rotate(angle) {
  return Curry._1(Css.style, {
              hd: Css.transform({
                    NAME: "rotate",
                    VAL: Css.deg(angle)
                  }),
              tl: {
                hd: Css.transition(400, 0, Css.ease, "all"),
                tl: /* [] */0
              }
            });
}

var accordionSection = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexDirection(Css.column),
        tl: /* [] */0
      }
    });

function inlineStyle(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8, prim9, prim10, prim11, prim12, prim13, prim14, prim15, prim16, prim17, prim18, prim19, prim20, prim21, prim22, prim23, prim24, prim25, prim26, prim27, prim28, prim29, prim30, prim31, prim32, prim33, prim34, prim35, prim36, prim37, prim38, prim39, prim40, prim41, prim42, prim43, prim44, prim45, prim46, prim47, prim48, prim49, prim50, prim51, prim52, prim53, prim54, prim55, prim56, prim57, prim58, prim59, prim60, prim61, prim62, prim63, prim64, prim65, prim66, prim67, prim68, prim69, prim70, prim71, prim72, prim73, prim74, prim75, prim76, prim77, prim78, prim79, prim80, prim81, prim82, prim83, prim84, prim85, prim86, prim87, prim88, prim89, prim90, prim91, prim92, prim93, prim94, prim95, prim96, prim97, prim98, prim99, prim100, prim101, prim102, prim103, prim104, prim105, prim106, prim107, prim108, prim109, prim110, prim111, prim112, prim113, prim114, prim115, prim116, prim117, prim118, prim119, prim120, prim121, prim122, prim123, prim124, prim125, prim126, prim127, prim128, prim129, prim130, prim131, prim132, prim133, prim134, prim135, prim136, prim137, prim138, prim139, prim140, prim141, prim142, prim143, prim144, prim145, prim146, prim147, prim148, prim149, prim150, prim151, prim152, prim153, prim154, prim155, prim156, prim157, prim158, prim159, prim160, prim161, prim162, prim163, prim164, prim165, prim166, prim167, prim168, prim169, prim170, prim171, prim172, prim173, prim174, prim175, prim176, prim177, prim178, prim179, prim180, prim181, prim182, prim183, prim184, prim185, prim186, prim187, prim188, prim189, prim190, prim191, prim192, prim193, prim194, prim195, prim196, prim197, prim198, prim199, prim200, prim201, prim202, prim203, prim204, prim205, prim206, prim207, prim208, prim209, prim210, prim211, prim212, prim213, prim214, prim215, prim216, prim217, prim218, prim219, prim220, prim221, prim222, prim223, prim224, prim225, prim226, prim227, prim228, prim229, prim230, prim231, prim232, prim233, prim234, prim235, prim236, prim237, prim238, prim239, prim240, prim241, prim242, prim243, prim244, prim245, prim246, prim247, prim248, prim249, prim250, prim251, prim252, prim253, prim254, prim255, prim256, prim257, prim258, prim259, prim260, prim261, prim262, prim263, prim264, prim265, prim266, prim267, prim268, prim269, prim270, prim271, prim272, prim273, prim274, prim275, prim276, prim277, prim278, prim279, prim280, prim281, prim282, prim283, prim284, prim285, prim286, prim287, prim288, prim289, prim290, prim291, prim292, prim293, prim294, prim295, prim296, prim297, prim298, prim299, prim300, prim301, prim302, prim303, prim304, prim305, prim306, prim307, prim308, prim309, prim310, prim311, prim312, prim313, prim314, prim315, prim316, prim317, prim318, prim319, prim320, prim321, prim322, prim323, prim324, prim325, prim326, prim327, prim328, prim329, prim330, prim331, prim332, prim333, prim334, prim335, prim336, prim337, prim338, prim339, prim340, prim341, prim342, prim343, prim344, prim345, prim346, prim347, prim348) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.azimuth = prim0;
  }
  if (prim1 !== undefined) {
    tmp.backdropFilter = prim1;
  }
  if (prim2 !== undefined) {
    tmp.background = prim2;
  }
  if (prim3 !== undefined) {
    tmp.backgroundAttachment = prim3;
  }
  if (prim4 !== undefined) {
    tmp.backgroundColor = prim4;
  }
  if (prim5 !== undefined) {
    tmp.backgroundImage = prim5;
  }
  if (prim6 !== undefined) {
    tmp.backgroundPosition = prim6;
  }
  if (prim7 !== undefined) {
    tmp.backgroundRepeat = prim7;
  }
  if (prim8 !== undefined) {
    tmp.border = prim8;
  }
  if (prim9 !== undefined) {
    tmp.borderCollapse = prim9;
  }
  if (prim10 !== undefined) {
    tmp.borderColor = prim10;
  }
  if (prim11 !== undefined) {
    tmp.borderSpacing = prim11;
  }
  if (prim12 !== undefined) {
    tmp.borderStyle = prim12;
  }
  if (prim13 !== undefined) {
    tmp.borderTop = prim13;
  }
  if (prim14 !== undefined) {
    tmp.borderRight = prim14;
  }
  if (prim15 !== undefined) {
    tmp.borderBottom = prim15;
  }
  if (prim16 !== undefined) {
    tmp.borderLeft = prim16;
  }
  if (prim17 !== undefined) {
    tmp.borderTopColor = prim17;
  }
  if (prim18 !== undefined) {
    tmp.borderRightColor = prim18;
  }
  if (prim19 !== undefined) {
    tmp.borderBottomColor = prim19;
  }
  if (prim20 !== undefined) {
    tmp.borderLeftColor = prim20;
  }
  if (prim21 !== undefined) {
    tmp.borderTopStyle = prim21;
  }
  if (prim22 !== undefined) {
    tmp.borderRightStyle = prim22;
  }
  if (prim23 !== undefined) {
    tmp.borderBottomStyle = prim23;
  }
  if (prim24 !== undefined) {
    tmp.borderLeftStyle = prim24;
  }
  if (prim25 !== undefined) {
    tmp.borderTopWidth = prim25;
  }
  if (prim26 !== undefined) {
    tmp.borderRightWidth = prim26;
  }
  if (prim27 !== undefined) {
    tmp.borderBottomWidth = prim27;
  }
  if (prim28 !== undefined) {
    tmp.borderLeftWidth = prim28;
  }
  if (prim29 !== undefined) {
    tmp.borderWidth = prim29;
  }
  if (prim30 !== undefined) {
    tmp.bottom = prim30;
  }
  if (prim31 !== undefined) {
    tmp.captionSide = prim31;
  }
  if (prim32 !== undefined) {
    tmp.clear = prim32;
  }
  if (prim33 !== undefined) {
    tmp.clip = prim33;
  }
  if (prim34 !== undefined) {
    tmp.color = prim34;
  }
  if (prim35 !== undefined) {
    tmp.content = prim35;
  }
  if (prim36 !== undefined) {
    tmp.counterIncrement = prim36;
  }
  if (prim37 !== undefined) {
    tmp.counterReset = prim37;
  }
  if (prim38 !== undefined) {
    tmp.cue = prim38;
  }
  if (prim39 !== undefined) {
    tmp.cueAfter = prim39;
  }
  if (prim40 !== undefined) {
    tmp.cueBefore = prim40;
  }
  if (prim41 !== undefined) {
    tmp.cursor = prim41;
  }
  if (prim42 !== undefined) {
    tmp.direction = prim42;
  }
  if (prim43 !== undefined) {
    tmp.display = prim43;
  }
  if (prim44 !== undefined) {
    tmp.elevation = prim44;
  }
  if (prim45 !== undefined) {
    tmp.emptyCells = prim45;
  }
  if (prim46 !== undefined) {
    tmp.float = prim46;
  }
  if (prim47 !== undefined) {
    tmp.font = prim47;
  }
  if (prim48 !== undefined) {
    tmp.fontFamily = prim48;
  }
  if (prim49 !== undefined) {
    tmp.fontSize = prim49;
  }
  if (prim50 !== undefined) {
    tmp.fontSizeAdjust = prim50;
  }
  if (prim51 !== undefined) {
    tmp.fontStretch = prim51;
  }
  if (prim52 !== undefined) {
    tmp.fontStyle = prim52;
  }
  if (prim53 !== undefined) {
    tmp.fontVariant = prim53;
  }
  if (prim54 !== undefined) {
    tmp.fontWeight = prim54;
  }
  if (prim55 !== undefined) {
    tmp.height = prim55;
  }
  if (prim56 !== undefined) {
    tmp.left = prim56;
  }
  if (prim57 !== undefined) {
    tmp.letterSpacing = prim57;
  }
  if (prim58 !== undefined) {
    tmp.lineHeight = prim58;
  }
  if (prim59 !== undefined) {
    tmp.listStyle = prim59;
  }
  if (prim60 !== undefined) {
    tmp.listStyleImage = prim60;
  }
  if (prim61 !== undefined) {
    tmp.listStylePosition = prim61;
  }
  if (prim62 !== undefined) {
    tmp.listStyleType = prim62;
  }
  if (prim63 !== undefined) {
    tmp.margin = prim63;
  }
  if (prim64 !== undefined) {
    tmp.marginTop = prim64;
  }
  if (prim65 !== undefined) {
    tmp.marginRight = prim65;
  }
  if (prim66 !== undefined) {
    tmp.marginBottom = prim66;
  }
  if (prim67 !== undefined) {
    tmp.marginLeft = prim67;
  }
  if (prim68 !== undefined) {
    tmp.markerOffset = prim68;
  }
  if (prim69 !== undefined) {
    tmp.marks = prim69;
  }
  if (prim70 !== undefined) {
    tmp.maxHeight = prim70;
  }
  if (prim71 !== undefined) {
    tmp.maxWidth = prim71;
  }
  if (prim72 !== undefined) {
    tmp.minHeight = prim72;
  }
  if (prim73 !== undefined) {
    tmp.minWidth = prim73;
  }
  if (prim74 !== undefined) {
    tmp.orphans = prim74;
  }
  if (prim75 !== undefined) {
    tmp.outline = prim75;
  }
  if (prim76 !== undefined) {
    tmp.outlineColor = prim76;
  }
  if (prim77 !== undefined) {
    tmp.outlineStyle = prim77;
  }
  if (prim78 !== undefined) {
    tmp.outlineWidth = prim78;
  }
  if (prim79 !== undefined) {
    tmp.overflow = prim79;
  }
  if (prim80 !== undefined) {
    tmp.overflowX = prim80;
  }
  if (prim81 !== undefined) {
    tmp.overflowY = prim81;
  }
  if (prim82 !== undefined) {
    tmp.padding = prim82;
  }
  if (prim83 !== undefined) {
    tmp.paddingTop = prim83;
  }
  if (prim84 !== undefined) {
    tmp.paddingRight = prim84;
  }
  if (prim85 !== undefined) {
    tmp.paddingBottom = prim85;
  }
  if (prim86 !== undefined) {
    tmp.paddingLeft = prim86;
  }
  if (prim87 !== undefined) {
    tmp.page = prim87;
  }
  if (prim88 !== undefined) {
    tmp.pageBreakAfter = prim88;
  }
  if (prim89 !== undefined) {
    tmp.pageBreakBefore = prim89;
  }
  if (prim90 !== undefined) {
    tmp.pageBreakInside = prim90;
  }
  if (prim91 !== undefined) {
    tmp.pause = prim91;
  }
  if (prim92 !== undefined) {
    tmp.pauseAfter = prim92;
  }
  if (prim93 !== undefined) {
    tmp.pauseBefore = prim93;
  }
  if (prim94 !== undefined) {
    tmp.pitch = prim94;
  }
  if (prim95 !== undefined) {
    tmp.pitchRange = prim95;
  }
  if (prim96 !== undefined) {
    tmp.playDuring = prim96;
  }
  if (prim97 !== undefined) {
    tmp.position = prim97;
  }
  if (prim98 !== undefined) {
    tmp.quotes = prim98;
  }
  if (prim99 !== undefined) {
    tmp.richness = prim99;
  }
  if (prim100 !== undefined) {
    tmp.right = prim100;
  }
  if (prim101 !== undefined) {
    tmp.size = prim101;
  }
  if (prim102 !== undefined) {
    tmp.speak = prim102;
  }
  if (prim103 !== undefined) {
    tmp.speakHeader = prim103;
  }
  if (prim104 !== undefined) {
    tmp.speakNumeral = prim104;
  }
  if (prim105 !== undefined) {
    tmp.speakPunctuation = prim105;
  }
  if (prim106 !== undefined) {
    tmp.speechRate = prim106;
  }
  if (prim107 !== undefined) {
    tmp.stress = prim107;
  }
  if (prim108 !== undefined) {
    tmp.tableLayout = prim108;
  }
  if (prim109 !== undefined) {
    tmp.textAlign = prim109;
  }
  if (prim110 !== undefined) {
    tmp.textDecoration = prim110;
  }
  if (prim111 !== undefined) {
    tmp.textIndent = prim111;
  }
  if (prim112 !== undefined) {
    tmp.textShadow = prim112;
  }
  if (prim113 !== undefined) {
    tmp.textTransform = prim113;
  }
  if (prim114 !== undefined) {
    tmp.top = prim114;
  }
  if (prim115 !== undefined) {
    tmp.unicodeBidi = prim115;
  }
  if (prim116 !== undefined) {
    tmp.verticalAlign = prim116;
  }
  if (prim117 !== undefined) {
    tmp.visibility = prim117;
  }
  if (prim118 !== undefined) {
    tmp.voiceFamily = prim118;
  }
  if (prim119 !== undefined) {
    tmp.volume = prim119;
  }
  if (prim120 !== undefined) {
    tmp.whiteSpace = prim120;
  }
  if (prim121 !== undefined) {
    tmp.widows = prim121;
  }
  if (prim122 !== undefined) {
    tmp.width = prim122;
  }
  if (prim123 !== undefined) {
    tmp.wordSpacing = prim123;
  }
  if (prim124 !== undefined) {
    tmp.zIndex = prim124;
  }
  if (prim125 !== undefined) {
    tmp.opacity = prim125;
  }
  if (prim126 !== undefined) {
    tmp.backgroundOrigin = prim126;
  }
  if (prim127 !== undefined) {
    tmp.backgroundSize = prim127;
  }
  if (prim128 !== undefined) {
    tmp.backgroundClip = prim128;
  }
  if (prim129 !== undefined) {
    tmp.borderRadius = prim129;
  }
  if (prim130 !== undefined) {
    tmp.borderTopLeftRadius = prim130;
  }
  if (prim131 !== undefined) {
    tmp.borderTopRightRadius = prim131;
  }
  if (prim132 !== undefined) {
    tmp.borderBottomLeftRadius = prim132;
  }
  if (prim133 !== undefined) {
    tmp.borderBottomRightRadius = prim133;
  }
  if (prim134 !== undefined) {
    tmp.borderImage = prim134;
  }
  if (prim135 !== undefined) {
    tmp.borderImageSource = prim135;
  }
  if (prim136 !== undefined) {
    tmp.borderImageSlice = prim136;
  }
  if (prim137 !== undefined) {
    tmp.borderImageWidth = prim137;
  }
  if (prim138 !== undefined) {
    tmp.borderImageOutset = prim138;
  }
  if (prim139 !== undefined) {
    tmp.borderImageRepeat = prim139;
  }
  if (prim140 !== undefined) {
    tmp.boxShadow = prim140;
  }
  if (prim141 !== undefined) {
    tmp.columns = prim141;
  }
  if (prim142 !== undefined) {
    tmp.columnCount = prim142;
  }
  if (prim143 !== undefined) {
    tmp.columnFill = prim143;
  }
  if (prim144 !== undefined) {
    tmp.columnGap = prim144;
  }
  if (prim145 !== undefined) {
    tmp.columnRule = prim145;
  }
  if (prim146 !== undefined) {
    tmp.columnRuleColor = prim146;
  }
  if (prim147 !== undefined) {
    tmp.columnRuleStyle = prim147;
  }
  if (prim148 !== undefined) {
    tmp.columnRuleWidth = prim148;
  }
  if (prim149 !== undefined) {
    tmp.columnSpan = prim149;
  }
  if (prim150 !== undefined) {
    tmp.columnWidth = prim150;
  }
  if (prim151 !== undefined) {
    tmp.breakAfter = prim151;
  }
  if (prim152 !== undefined) {
    tmp.breakBefore = prim152;
  }
  if (prim153 !== undefined) {
    tmp.breakInside = prim153;
  }
  if (prim154 !== undefined) {
    tmp.rest = prim154;
  }
  if (prim155 !== undefined) {
    tmp.restAfter = prim155;
  }
  if (prim156 !== undefined) {
    tmp.restBefore = prim156;
  }
  if (prim157 !== undefined) {
    tmp.speakAs = prim157;
  }
  if (prim158 !== undefined) {
    tmp.voiceBalance = prim158;
  }
  if (prim159 !== undefined) {
    tmp.voiceDuration = prim159;
  }
  if (prim160 !== undefined) {
    tmp.voicePitch = prim160;
  }
  if (prim161 !== undefined) {
    tmp.voiceRange = prim161;
  }
  if (prim162 !== undefined) {
    tmp.voiceRate = prim162;
  }
  if (prim163 !== undefined) {
    tmp.voiceStress = prim163;
  }
  if (prim164 !== undefined) {
    tmp.voiceVolume = prim164;
  }
  if (prim165 !== undefined) {
    tmp.objectFit = prim165;
  }
  if (prim166 !== undefined) {
    tmp.objectPosition = prim166;
  }
  if (prim167 !== undefined) {
    tmp.imageResolution = prim167;
  }
  if (prim168 !== undefined) {
    tmp.imageOrientation = prim168;
  }
  if (prim169 !== undefined) {
    tmp.alignContent = prim169;
  }
  if (prim170 !== undefined) {
    tmp.alignItems = prim170;
  }
  if (prim171 !== undefined) {
    tmp.alignSelf = prim171;
  }
  if (prim172 !== undefined) {
    tmp.flex = prim172;
  }
  if (prim173 !== undefined) {
    tmp.flexBasis = prim173;
  }
  if (prim174 !== undefined) {
    tmp.flexDirection = prim174;
  }
  if (prim175 !== undefined) {
    tmp.flexFlow = prim175;
  }
  if (prim176 !== undefined) {
    tmp.flexGrow = prim176;
  }
  if (prim177 !== undefined) {
    tmp.flexShrink = prim177;
  }
  if (prim178 !== undefined) {
    tmp.flexWrap = prim178;
  }
  if (prim179 !== undefined) {
    tmp.justifyContent = prim179;
  }
  if (prim180 !== undefined) {
    tmp.order = prim180;
  }
  if (prim181 !== undefined) {
    tmp.textDecorationColor = prim181;
  }
  if (prim182 !== undefined) {
    tmp.textDecorationLine = prim182;
  }
  if (prim183 !== undefined) {
    tmp.textDecorationSkip = prim183;
  }
  if (prim184 !== undefined) {
    tmp.textDecorationStyle = prim184;
  }
  if (prim185 !== undefined) {
    tmp.textEmphasis = prim185;
  }
  if (prim186 !== undefined) {
    tmp.textEmphasisColor = prim186;
  }
  if (prim187 !== undefined) {
    tmp.textEmphasisPosition = prim187;
  }
  if (prim188 !== undefined) {
    tmp.textEmphasisStyle = prim188;
  }
  if (prim189 !== undefined) {
    tmp.textUnderlinePosition = prim189;
  }
  if (prim190 !== undefined) {
    tmp.fontFeatureSettings = prim190;
  }
  if (prim191 !== undefined) {
    tmp.fontKerning = prim191;
  }
  if (prim192 !== undefined) {
    tmp.fontLanguageOverride = prim192;
  }
  if (prim193 !== undefined) {
    tmp.fontSynthesis = prim193;
  }
  if (prim194 !== undefined) {
    tmp.forntVariantAlternates = prim194;
  }
  if (prim195 !== undefined) {
    tmp.fontVariantCaps = prim195;
  }
  if (prim196 !== undefined) {
    tmp.fontVariantEastAsian = prim196;
  }
  if (prim197 !== undefined) {
    tmp.fontVariantLigatures = prim197;
  }
  if (prim198 !== undefined) {
    tmp.fontVariantNumeric = prim198;
  }
  if (prim199 !== undefined) {
    tmp.fontVariantPosition = prim199;
  }
  if (prim200 !== undefined) {
    tmp.all = prim200;
  }
  if (prim201 !== undefined) {
    tmp.glyphOrientationVertical = prim201;
  }
  if (prim202 !== undefined) {
    tmp.textCombineUpright = prim202;
  }
  if (prim203 !== undefined) {
    tmp.textOrientation = prim203;
  }
  if (prim204 !== undefined) {
    tmp.writingMode = prim204;
  }
  if (prim205 !== undefined) {
    tmp.shapeImageThreshold = prim205;
  }
  if (prim206 !== undefined) {
    tmp.shapeMargin = prim206;
  }
  if (prim207 !== undefined) {
    tmp.shapeOutside = prim207;
  }
  if (prim208 !== undefined) {
    tmp.clipPath = prim208;
  }
  if (prim209 !== undefined) {
    tmp.clipRule = prim209;
  }
  if (prim210 !== undefined) {
    tmp.mask = prim210;
  }
  if (prim211 !== undefined) {
    tmp.maskBorder = prim211;
  }
  if (prim212 !== undefined) {
    tmp.maskBorderMode = prim212;
  }
  if (prim213 !== undefined) {
    tmp.maskBorderOutset = prim213;
  }
  if (prim214 !== undefined) {
    tmp.maskBorderRepeat = prim214;
  }
  if (prim215 !== undefined) {
    tmp.maskBorderSlice = prim215;
  }
  if (prim216 !== undefined) {
    tmp.maskBorderSource = prim216;
  }
  if (prim217 !== undefined) {
    tmp.maskBorderWidth = prim217;
  }
  if (prim218 !== undefined) {
    tmp.maskClip = prim218;
  }
  if (prim219 !== undefined) {
    tmp.maskComposite = prim219;
  }
  if (prim220 !== undefined) {
    tmp.maskImage = prim220;
  }
  if (prim221 !== undefined) {
    tmp.maskMode = prim221;
  }
  if (prim222 !== undefined) {
    tmp.maskOrigin = prim222;
  }
  if (prim223 !== undefined) {
    tmp.maskPosition = prim223;
  }
  if (prim224 !== undefined) {
    tmp.maskRepeat = prim224;
  }
  if (prim225 !== undefined) {
    tmp.maskSize = prim225;
  }
  if (prim226 !== undefined) {
    tmp.maskType = prim226;
  }
  if (prim227 !== undefined) {
    tmp.backgroundBlendMode = prim227;
  }
  if (prim228 !== undefined) {
    tmp.isolation = prim228;
  }
  if (prim229 !== undefined) {
    tmp.mixBlendMode = prim229;
  }
  if (prim230 !== undefined) {
    tmp.boxDecorationBreak = prim230;
  }
  if (prim231 !== undefined) {
    tmp.boxSizing = prim231;
  }
  if (prim232 !== undefined) {
    tmp.caretColor = prim232;
  }
  if (prim233 !== undefined) {
    tmp.navDown = prim233;
  }
  if (prim234 !== undefined) {
    tmp.navLeft = prim234;
  }
  if (prim235 !== undefined) {
    tmp.navRight = prim235;
  }
  if (prim236 !== undefined) {
    tmp.navUp = prim236;
  }
  if (prim237 !== undefined) {
    tmp.outlineOffset = prim237;
  }
  if (prim238 !== undefined) {
    tmp.resize = prim238;
  }
  if (prim239 !== undefined) {
    tmp.textOverflow = prim239;
  }
  if (prim240 !== undefined) {
    tmp.grid = prim240;
  }
  if (prim241 !== undefined) {
    tmp.gridArea = prim241;
  }
  if (prim242 !== undefined) {
    tmp.gridAutoColumns = prim242;
  }
  if (prim243 !== undefined) {
    tmp.gridAutoFlow = prim243;
  }
  if (prim244 !== undefined) {
    tmp.gridAutoRows = prim244;
  }
  if (prim245 !== undefined) {
    tmp.gridColumn = prim245;
  }
  if (prim246 !== undefined) {
    tmp.gridColumnEnd = prim246;
  }
  if (prim247 !== undefined) {
    tmp.gridColumnGap = prim247;
  }
  if (prim248 !== undefined) {
    tmp.gridColumnStart = prim248;
  }
  if (prim249 !== undefined) {
    tmp.gridGap = prim249;
  }
  if (prim250 !== undefined) {
    tmp.gridRow = prim250;
  }
  if (prim251 !== undefined) {
    tmp.gridRowEnd = prim251;
  }
  if (prim252 !== undefined) {
    tmp.gridRowGap = prim252;
  }
  if (prim253 !== undefined) {
    tmp.gridRowStart = prim253;
  }
  if (prim254 !== undefined) {
    tmp.gridTemplate = prim254;
  }
  if (prim255 !== undefined) {
    tmp.gridTemplateAreas = prim255;
  }
  if (prim256 !== undefined) {
    tmp.gridTemplateColumns = prim256;
  }
  if (prim257 !== undefined) {
    tmp.gridTemplateRows = prim257;
  }
  if (prim258 !== undefined) {
    tmp.willChange = prim258;
  }
  if (prim259 !== undefined) {
    tmp.hangingPunctuation = prim259;
  }
  if (prim260 !== undefined) {
    tmp.hyphens = prim260;
  }
  if (prim261 !== undefined) {
    tmp.lineBreak = prim261;
  }
  if (prim262 !== undefined) {
    tmp.overflowWrap = prim262;
  }
  if (prim263 !== undefined) {
    tmp.tabSize = prim263;
  }
  if (prim264 !== undefined) {
    tmp.textAlignLast = prim264;
  }
  if (prim265 !== undefined) {
    tmp.textJustify = prim265;
  }
  if (prim266 !== undefined) {
    tmp.wordBreak = prim266;
  }
  if (prim267 !== undefined) {
    tmp.wordWrap = prim267;
  }
  if (prim268 !== undefined) {
    tmp.animation = prim268;
  }
  if (prim269 !== undefined) {
    tmp.animationDelay = prim269;
  }
  if (prim270 !== undefined) {
    tmp.animationDirection = prim270;
  }
  if (prim271 !== undefined) {
    tmp.animationDuration = prim271;
  }
  if (prim272 !== undefined) {
    tmp.animationFillMode = prim272;
  }
  if (prim273 !== undefined) {
    tmp.animationIterationCount = prim273;
  }
  if (prim274 !== undefined) {
    tmp.animationName = prim274;
  }
  if (prim275 !== undefined) {
    tmp.animationPlayState = prim275;
  }
  if (prim276 !== undefined) {
    tmp.animationTimingFunction = prim276;
  }
  if (prim277 !== undefined) {
    tmp.transition = prim277;
  }
  if (prim278 !== undefined) {
    tmp.transitionDelay = prim278;
  }
  if (prim279 !== undefined) {
    tmp.transitionDuration = prim279;
  }
  if (prim280 !== undefined) {
    tmp.transitionProperty = prim280;
  }
  if (prim281 !== undefined) {
    tmp.transitionTimingFunction = prim281;
  }
  if (prim282 !== undefined) {
    tmp.backfaceVisibility = prim282;
  }
  if (prim283 !== undefined) {
    tmp.perspective = prim283;
  }
  if (prim284 !== undefined) {
    tmp.perspectiveOrigin = prim284;
  }
  if (prim285 !== undefined) {
    tmp.transform = prim285;
  }
  if (prim286 !== undefined) {
    tmp.transformOrigin = prim286;
  }
  if (prim287 !== undefined) {
    tmp.transformStyle = prim287;
  }
  if (prim288 !== undefined) {
    tmp.justifyItems = prim288;
  }
  if (prim289 !== undefined) {
    tmp.justifySelf = prim289;
  }
  if (prim290 !== undefined) {
    tmp.placeContent = prim290;
  }
  if (prim291 !== undefined) {
    tmp.placeItems = prim291;
  }
  if (prim292 !== undefined) {
    tmp.placeSelf = prim292;
  }
  if (prim293 !== undefined) {
    tmp.appearance = prim293;
  }
  if (prim294 !== undefined) {
    tmp.caret = prim294;
  }
  if (prim295 !== undefined) {
    tmp.caretAnimation = prim295;
  }
  if (prim296 !== undefined) {
    tmp.caretShape = prim296;
  }
  if (prim297 !== undefined) {
    tmp.userSelect = prim297;
  }
  if (prim298 !== undefined) {
    tmp.maxLines = prim298;
  }
  if (prim299 !== undefined) {
    tmp.marqueeDirection = prim299;
  }
  if (prim300 !== undefined) {
    tmp.marqueeLoop = prim300;
  }
  if (prim301 !== undefined) {
    tmp.marqueeSpeed = prim301;
  }
  if (prim302 !== undefined) {
    tmp.marqueeStyle = prim302;
  }
  if (prim303 !== undefined) {
    tmp.overflowStyle = prim303;
  }
  if (prim304 !== undefined) {
    tmp.rotation = prim304;
  }
  if (prim305 !== undefined) {
    tmp.rotationPoint = prim305;
  }
  if (prim306 !== undefined) {
    tmp.alignmentBaseline = prim306;
  }
  if (prim307 !== undefined) {
    tmp.baselineShift = prim307;
  }
  if (prim308 !== undefined) {
    tmp.clip = prim308;
  }
  if (prim309 !== undefined) {
    tmp.clipPath = prim309;
  }
  if (prim310 !== undefined) {
    tmp.clipRule = prim310;
  }
  if (prim311 !== undefined) {
    tmp.colorInterpolation = prim311;
  }
  if (prim312 !== undefined) {
    tmp.colorInterpolationFilters = prim312;
  }
  if (prim313 !== undefined) {
    tmp.colorProfile = prim313;
  }
  if (prim314 !== undefined) {
    tmp.colorRendering = prim314;
  }
  if (prim315 !== undefined) {
    tmp.cursor = prim315;
  }
  if (prim316 !== undefined) {
    tmp.dominantBaseline = prim316;
  }
  if (prim317 !== undefined) {
    tmp.fill = prim317;
  }
  if (prim318 !== undefined) {
    tmp.fillOpacity = prim318;
  }
  if (prim319 !== undefined) {
    tmp.fillRule = prim319;
  }
  if (prim320 !== undefined) {
    tmp.filter = prim320;
  }
  if (prim321 !== undefined) {
    tmp.floodColor = prim321;
  }
  if (prim322 !== undefined) {
    tmp.floodOpacity = prim322;
  }
  if (prim323 !== undefined) {
    tmp.glyphOrientationHorizontal = prim323;
  }
  if (prim324 !== undefined) {
    tmp.glyphOrientationVertical = prim324;
  }
  if (prim325 !== undefined) {
    tmp.imageRendering = prim325;
  }
  if (prim326 !== undefined) {
    tmp.kerning = prim326;
  }
  if (prim327 !== undefined) {
    tmp.lightingColor = prim327;
  }
  if (prim328 !== undefined) {
    tmp.markerEnd = prim328;
  }
  if (prim329 !== undefined) {
    tmp.markerMid = prim329;
  }
  if (prim330 !== undefined) {
    tmp.markerStart = prim330;
  }
  if (prim331 !== undefined) {
    tmp.pointerEvents = prim331;
  }
  if (prim332 !== undefined) {
    tmp.shapeRendering = prim332;
  }
  if (prim333 !== undefined) {
    tmp.stopColor = prim333;
  }
  if (prim334 !== undefined) {
    tmp.stopOpacity = prim334;
  }
  if (prim335 !== undefined) {
    tmp.stroke = prim335;
  }
  if (prim336 !== undefined) {
    tmp.strokeDasharray = prim336;
  }
  if (prim337 !== undefined) {
    tmp.strokeDashoffset = prim337;
  }
  if (prim338 !== undefined) {
    tmp.strokeLinecap = prim338;
  }
  if (prim339 !== undefined) {
    tmp.strokeLinejoin = prim339;
  }
  if (prim340 !== undefined) {
    tmp.strokeMiterlimit = prim340;
  }
  if (prim341 !== undefined) {
    tmp.strokeOpacity = prim341;
  }
  if (prim342 !== undefined) {
    tmp.strokeWidth = prim342;
  }
  if (prim343 !== undefined) {
    tmp.textAnchor = prim343;
  }
  if (prim344 !== undefined) {
    tmp.textRendering = prim344;
  }
  if (prim345 !== undefined) {
    tmp.rubyAlign = prim345;
  }
  if (prim346 !== undefined) {
    tmp.rubyMerge = prim346;
  }
  if (prim347 !== undefined) {
    tmp.rubyPosition = prim347;
  }
  return tmp;
}

function FAQs$Chevron(props) {
  return React.createElement("svg", {
              className: props.className,
              height: "14px",
              width: "14px",
              viewBox: "0 0 320 512"
            }, React.createElement("path", {
                  d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z",
                  fill: "#777"
                }));
}

var Chevron = {
  make: FAQs$Chevron
};

function FAQs$FaqItem(props) {
  var toggleAccordion = props.toggleAccordion;
  var isOpen = props.isOpen;
  var match = React.useState(function () {
        return "0px";
      });
  var setHeight = match[1];
  var accordianContentRef = React.useRef(null);
  React.useEffect((function () {
          var __x = accordianContentRef.current;
          var optHeight = Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (prim) {
                  return prim.scrollHeight;
                }));
          var height = optHeight !== undefined ? String(optHeight) + "px" : "0px";
          Curry._1(setHeight, (function (param) {
                  if (isOpen) {
                    return height;
                  } else {
                    return "0px";
                  }
                }));
        }), [
        isOpen,
        setHeight
      ]);
  return React.createElement(React.Fragment, {
              children: null
            }, React.createElement("div", {
                  onClick: (function (param) {
                      Curry._1(toggleAccordion, undefined);
                    })
                }, React.createElement(RimbleUi.Text, {
                      children: null,
                      className: "accordion-title"
                    }, props.title, React.createElement(FAQs$Chevron, {
                          className: rotate(isOpen ? 90 : 0)
                        }))), React.createElement("div", {
                  ref: Caml_option.some(accordianContentRef),
                  className: accordionContent,
                  style: inlineStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, match[0], undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                }, React.createElement("div", undefined, React.createElement("div", {
                          className: faqExplainerText
                        }, React.createElement(RimbleUi.Text, {
                              children: props.content,
                              className: Styles.colorGrey
                            })))));
}

var FaqItem = {
  make: FAQs$FaqItem
};

var content = [
  {
    title: "Do the different wildcards represent real animals?",
    content: "Some wildcards do represent real animals, while other wildcards are symoblic of the coservation efforts of that organisation. When partnering with a conservation organisation, if that organisation has specific ainimals they track and care for, we aim to list those real animals. In other cases, conservation efforts can occur on a more macro level (without specific animals). To raise funds for these efforts we create an animal representative of that organisation. In both cases, an animal will simply represent an organisation, and funds generated from that animal will flow to the organisation it represents."
  },
  {
    title: "How do I know my funds are going to the organization?",
    content: React.createElement(React.Fragment, {
          children: null
        }, "Our platform uses ethereum (a blockchain), which is essentially a public transaction ledger. This means that every single action happening on this platform is completely public, verifiable and auditable. If you would like to learn more, ", React.createElement("a", {
              href: "https://blog.wildcards.world/where-is-the-money-going/",
              rel: "noopener noreferrer",
              target: "_blank"
            }, "read our blog post"), "  which details how funds are transparently recieved by our conservation partners.")
  },
  {
    title: "Can I only buy a wildcard using cryptocurrency?",
    content: React.createElement(React.Fragment, {
          children: null
        }, "Unfortunately, for now cryptocurrency is the only way to buy a wildcard. We are actively working on FIAT currency solutions. In the mean time, we have intergrated with Torus, allowing you to use your credit card easily to buy the required ETH necessary to purchase a wildcard.", React.createElement("a", {
              href: "https://blog.wildcards.world/how-to-buy-a-wildcard-web3-ethereum/",
              rel: "noopener noreferrer",
              target: "_blank"
            }, " Read our guide"), " to find out more about how to buy a wildcard.")
  },
  {
    title: "What is a non-fungible token?",
    content: "A non-fungible token (NFT), is simply put, a token that is unique. This is in contrast to bitcoin (which is fungible), as each bitcoin is always equivalent to another one in value. Every wildcard is an NFT representing a unique animal. Since wildcards are non-fungible (unique), every wildcard has a unique history and independant value."
  },
  {
    title: "What does 'always for sale' mean?",
    content: "Always for sale means exactly what it says, the asset or thing in question can be bought by any person at anytime, and is hence, always for sale. How this functions in practice is very interesting. The owner of the asset is required to always have a listed selling price for this asset at which anyone could buy this asset from them at any point in time. The owner won’t set the selling price too high because they are required to continually pay a percentage of the selling price in order to keep ownership of the asset."
  },
  {
    title: "What is a deposit and what happens if my deposit runs out?",
    content: "Your deposit is used to contiually pay the percentage fee of the selling price you set, in order for you to continue your ownership of the asset. If your deposit runs out then anyone can claim the asset for free and set a new selling price."
  },
  {
    title: "Can I join wildcards and raise funds for my animal conservation project?",
    content: "Yes! Please send an email to jonjon@wildcards.world"
  }
];

function FAQs(props) {
  var match = React.useState(function () {
        return -1;
      });
  var setActiveIndex = match[1];
  var activeIndex = match[0];
  return React.createElement("div", {
              className: Styles.infoBackground
            }, React.createElement(RimbleUi.Box, {
                  children: React.createElement(RimbleUi.Flex, {
                        children: React.createElement(RimbleUi.Box, {
                              children: React.createElement(RimbleUi.Card, {
                                    children: null
                                  }, React.createElement(RimbleUi.Heading, {
                                        children: "Frequently Asked Questions (FAQs)"
                                      }), React.createElement("div", {
                                        className: accordionSection
                                      }, Belt_Array.mapWithIndex(content, (function (index, param) {
                                              return JsxPPXReactSupport.createElementWithKey(String(index), FAQs$FaqItem, {
                                                          isOpen: index === activeIndex,
                                                          toggleAccordion: (function (param) {
                                                              return Curry._1(setActiveIndex, (function (param) {
                                                                            if (index === activeIndex) {
                                                                              return -1;
                                                                            } else {
                                                                              return index;
                                                                            }
                                                                          }));
                                                            }),
                                                          title: param.title,
                                                          content: param.content
                                                        });
                                            })))),
                              width: [1]
                            }),
                        flexWrap: "wrap",
                        alignItems: "center",
                        className: Styles.floatingSignupBoxInner
                      }),
                  className: Styles.floatingSignupBox
                }));
}

var make = FAQs;

export {
  faqExplainerText ,
  accordionContent ,
  rotate ,
  accordionSection ,
  inlineStyle ,
  Chevron ,
  FaqItem ,
  content ,
  make ,
}
/* faqExplainerText Not a pure module */
